export const enumSecteursPorteurs = {
    IMMOBILIER: "Immobilier",
    COMPTABILITE: "Comptabilité",
    DATASCIENCE: "Data Science / IA",
    INFORMATIQUE: "Développement informatique",
    MULTIMEDIA: "Multimédia",
    RH: "Ressources humaines"
}